import { useState } from 'react'
import Header from "../components/Header";
import Footer from "../components/Footer";
import ContactSection from '../components/Contact/contactsection';
import TitleBanner from '../components/titlebanner';

export default function Contact() {
   


    return (
        <>
        <Header/>
        <TitleBanner title={"Contact Us"}/>
        <ContactSection/>
        <Footer/>
        </>
        
    )
}